import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { O5_CLUSTER_BASE_PATH } from '../../../../../../features/o5/cluster/o5-cluster-routing';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/cluster/_cluster')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'o5-cluster-list',
        label: 'Clusters',
        to: O5_CLUSTER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
